export default [
  {
    path: '/form-reread/index',
    name: 'index',
    component: () => import('@/views/form-reread/index'),
    meta: {
      title: '高三复读评估'
    }
  },
  {
    path: '/form-reread/report',
    name: 'report',
    component: () => import('@/views/form-reread/report'),
    meta: {
      title: '高三复读评估'
    }
  },
]
